import { PageTitle } from '_metronic/layout/core'
import { WithChildren } from '_metronic/helpers'

import PageBreadCrumb from 'Presentation/Components/PageBreadCrumb'
import InfiniteScroll from 'react-infinite-scroll-component'

import { KTSVG } from '_metronic/helpers'
import RequestCard from './Components/RequestCard'
import Filter from './Components/Filter'

import useViewModel from './ViewModel'
import { IssueType } from 'Configuration/Paco'

const RequestListMobileView = () => {
  const {
    filter,
    submitFilter,
    onChangeFilter,
    clearFilter,
    mobileData,
    totalCountMobileData,
    nextPageMobile,
    viewRequest,
    createRequest,
  } = useViewModel()

  return (
    <ViewPageTitle>
      <Filter
        filter={filter}
        onChangeFilter={onChangeFilter}
        onSubmit={submitFilter}
        onClearFilter={clearFilter}
      />

      <div>
        <div className='mb-5 shadow-lg overflow-hidden rounded-3'>
          <PageBreadCrumb />
        </div>

        <button
          onClick={() => createRequest(IssueType.RequestSteelPlates)}
          className='btn btn-sm btn-success fw-bold w-100 mb-5'
          style={{ whiteSpace: 'nowrap' }}>
          <KTSVG path='/media/icons/duotune/general/gen041.svg' svgClassName='svg-icon-1' />
          ขอแผ่นเหล็ก
        </button>

        <button
          onClick={() => createRequest(IssueType.RequestChangePileSize)}
          className='btn btn-sm btn-success fw-bold w-100 mb-5'
          style={{ whiteSpace: 'nowrap' }}>
          <KTSVG path='/media/icons/duotune/general/gen041.svg' svgClassName='svg-icon-1' />
          เปลี่ยนแปลงขนาดเสา
        </button>

        <button
          onClick={() => createRequest(IssueType.RequestChangeShipping)}
          className='btn btn-sm btn-success fw-bold w-100 mb-5'
          style={{ whiteSpace: 'nowrap' }}>
          <KTSVG path='/media/icons/duotune/general/gen041.svg' svgClassName='svg-icon-1' />
          เพิ่มจำนวน (ขนส่ง)
        </button>

        <button id='kt_request_filter_toggle' className='btn btn-sm btn-primary w-100'>
          <KTSVG path='/media/icons/duotune/general/gen031.svg' svgClassName='svg-icon-1' /> ตัวกรอง
        </button>

        <InfiniteScroll
          dataLength={totalCountMobileData}
          next={nextPageMobile}
          hasMore={mobileData.length < totalCountMobileData}
          loader={<h4 className='text-center'>กำลังโหลด...</h4>}>
          {mobileData.map((item, index) => (
            <RequestCard key={index} {...item} onClick={viewRequest} />
          ))}
        </InfiniteScroll>
      </div>
    </ViewPageTitle>
  )
}

const ViewPageTitle: React.FC<WithChildren> = ({ children }) => {
  return (
    <>
      <PageTitle
        breadcrumbs={[
          {
            isActive: true,
            isSeparator: false,
            path: '#',
            title: 'รายการทั้งหมด',
            icon: '/media/icons/duotune/files/fil005.svg',
          },
        ]}>
        คำร้องขอ
      </PageTitle>

      {children}
    </>
  )
}

export default RequestListMobileView
